var map = {
	"./goro-banner-1.jpg": 90867,
	"./goro-banner-10.jpg": 49387,
	"./goro-banner-11.jpg": 71342,
	"./goro-banner-2.jpg": 13060,
	"./goro-banner-3.jpg": 91105,
	"./goro-banner-4.jpg": 65618,
	"./goro-banner-5.jpg": 37999,
	"./goro-banner-6.jpg": 24384,
	"./goro-banner-7.jpg": 75517,
	"./goro-banner-8.jpg": 1246,
	"./goro-banner-9.jpg": 32731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3871;